import { type ClientToServerEvents, SOCKET_PATH, type ServerToClientEvents } from '@penalty-cup/shared';
import { type Socket, io } from 'socket.io-client';

export type GameSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/** Сокет игры: вход токеном доступа; при обрыве переподключается сам, сервер присылает состояние матча. */
export function connectGame(token: string): GameSocket {
  return io({
    path: SOCKET_PATH,
    transports: ['websocket'],
    auth: { token },
    reconnectionDelay: 500,
    reconnectionDelayMax: 3000,
  });
}
